import order from "./handlers/order";
import printLog from "./handlers/printLog";
import template from "./handlers/template";
import account from "./handlers/account";
import sender from "./handlers/sender";
import shop from "./handlers/shop";
import product from './handlers/product';
import {taskhandler,cancelTask} from './handlers/task';
import form from './handlers/form'
export const handlers = [
  // Handles a GET /user request
  order,
  printLog,
  template,
  account,
  sender,
  shop,
  product,
  form,
  taskhandler,
  cancelTask
];
